export const informationCardWrapperStyle = {
  height: '24.5625rem',
  mt: 2,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: 2,
  p: 4,
} as const;

export const informationCardImgStyle = {
  width: '14.375rem',
  height: '12.5rem',
  objectFit: 'contain',
} as const;

export const informationCardDescriptionStyle = {
  maxWidth: '19.75rem',
  textAlign: 'center',
} as const;
